import React, { useRef, useState } from "react";
import { toast, ToastContainer } from "react-toastify";
// @ts-ignore
import { db } from "../../utils/firebase";
import * as XLSX from "xlsx";
import { doc, getDoc, setDoc } from "firebase/firestore";

const UploadMenu = () => {
  const [formData, setFormData] = useState({
    email: "",
    businessName: "",
  });

  const [file, setFile] = useState<File | null>(null);
  const [uploading, setUploading] = useState(false);
  const [error, setError] = useState("");
  const [menuType, setMenuType] = useState("englishMenu");
  const [mergeExisting, setMergeExisting] = useState(false);
  const fileInputRef = useRef<any>(null);

  //console.log(menuType, "sdcscsdcsdcscd");
  const handleChange = (e: any) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
    setError("");
  };

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const selectedFile = e.target.files?.[0];
    if (selectedFile) {
      setFile(selectedFile);
    }
    setError("");
  };

  const generateId = () => {
    const id = formData?.businessName
      .toLowerCase()
      .replace(/\s+/g, "-")
      .replace(/[^a-z0-9-]/g, "");
    //console.log("id", id);
    setFormData((prev) => ({ ...prev, businessName: id }));
  };

  const handleUpload = async () => {
    if (!file || !formData.businessName || !formData.email) {
      if (!formData.email) {
        setError("Please enter an email");
        return;
      }
      if (!file) {
        setError("Please select a file ");
        return;
      } else {
        setError("Please enter a business name.");
        return;
      }
    }

    setUploading(true);
    setError("");

    try {
      const reader = new FileReader();
      reader.onload = async (e) => {
        const data = e.target?.result;
        if (data) {
          const workbook = XLSX.read(data, { type: "binary" });
          const sheetName = workbook.SheetNames[0];
          const sheet = workbook.Sheets[sheetName];
          let jsonData: any[] = XLSX.utils.sheet_to_json(sheet, {
            defval: null,
          });

          if (jsonData.length > 0) {
            const keys = Object.keys(jsonData[0]);
            keys.forEach((key) => {
              let lastValue: any = null;
              jsonData.forEach((row) => {
                if (!row[key]) {
                  row[key] = lastValue;
                } else {
                  lastValue = row[key];
                }
              });
            });
          }
          //console.log("menuuu", jsonData, "foromom", formData);

          const businessRef = doc(db, "menus", formData.businessName);
          const docSnap = await getDoc(businessRef);

          if (docSnap.exists() && !mergeExisting) {
            //console.log("dfvdbvjbdjhvbjbf");
            setError("Business ID already exists. Check the box to merge.");
            return;
          } else if (docSnap.exists() && mergeExisting) {
            await setDoc(
              businessRef,
              { [menuType]: jsonData, email: formData.email },
              { merge: true }
            );
            setFile(null);
            fileInputRef.current.value = "";
          } else {
            console.log("Document does not exist, creating a new one.");
            await setDoc(businessRef, {
              [menuType]: jsonData,
              email: formData.email,
            });
            setFile(null);
            fileInputRef.current.value = "";
          }
          toast.success("Menu uploaded successfully!");
        }
      };
      reader.readAsBinaryString(file);
    } catch (err) {
      setError("Failed to upload menu. Please try again.");
      console.error(err);
    } finally {
      setUploading(false);
    }
  };

  const resetField = () => {
    setFormData({
      email: "",
      businessName: "",
    });
    setMenuType("englishMenu");
    setFile(null);
    if (fileInputRef?.current) {
        //@ts-ignore
        fileInputRef.current.value = "";
      }
  };

  return (
    <div className="max-w-2xl bg-white rounded-lg shadow p-4 lg:p-6">
      <ToastContainer position="top-right" autoClose={3000} hideProgressBar />
      <div className="flex justify-between self-center">
        <h2 className="text-xl font-bold mb-6">Upload Menu</h2>
        <button
          onClick={resetField}
          className="text-md font-bold bg-gradient-to-r from-[#0b3a28] to-[#041d14] text-white py-0 px-5 rounded-lg font-semibold hover:from-[#283832] hover:to-[#294339] transition duration-300 disabled:opacity-50 shadow-md"
        >
          Reset field
        </button>
      </div>
      <div className="space-y-4">
        {/* Business Name */}
        <div>
          <label className="block text-sm font-medium text-gray-700">
            Business Name
          </label>
          <div className="flex self-center gap-3">
            <input
              type="text"
              name="businessName"
              value={formData.businessName}
              onChange={handleChange}
              className="w-full mt-2 border px-4 py-2 rounded-lg focus:ring-2 focus:ring-blue-500 outline-none"
            />
            <button
              disabled={formData?.businessName === ""}
              onClick={generateId}
              className="w-32 bg-[#0b3a28] text-white self-center py-2 rounded-lg hover:bg-[#1c2822]"
            >
              Create Id
            </button>
          </div>
        </div>

        {/* Email */}
        <div>
          <label className="block text-sm font-medium text-gray-700">
            Email
          </label>
          <input
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            required
            className="w-full mt-2 border rounded-lg px-4 py-2 focus:ring-2 focus:ring-blue-500 outline-none"
          />
        </div>

        {/* Menu Type Selection */}
        <div>
          <label className="block text-sm font-medium text-gray-700">
            Menu Language
          </label>
          <select
            value={menuType}
            onChange={(e) => setMenuType(e.target.value)}
            className="w-full mt-2 border px-4 py-2 rounded-lg focus:ring-2 focus:ring-blue-500 outline-none"
          >
            <option value="englishMenu">English</option>
            <option value="hindiMenu">Hindi</option>
          </select>
        </div>

        {/* Upload Excel File */}
        <div>
          <label className="block text-lg font-medium text-gray-800 mb-2">
            Upload Excel File
          </label>
          <input
            type="file"
            ref={fileInputRef} // Assign the ref
            accept=".xlsx, .xls"
            onChange={handleFileChange}
            className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 outline-none bg-gray-50"
          />
        </div>
        <label className="flex items-center space-x-2">
          <input
            type="checkbox"
            checked={mergeExisting}
            onChange={(e) => {
              setMergeExisting(e.target.checked);
              setError("");
            }}
          />
          <span>Merge if Business ID exists</span>
        </label>
        {error && <p className="text-red-500 text-sm text-center">{error}</p>}

        <button
          onClick={handleUpload}
          disabled={uploading || !!error}
          className="w-full bg-gradient-to-r from-[#0b3a28] to-[#041d14] text-white py-3 px-6 rounded-lg font-semibold hover:from-[#283832] hover:to-[#294339] transition duration-300 disabled:opacity-50 shadow-md"
        >
          {uploading ? "Uploading..." : "Upload Menu"}
        </button>
      </div>
    </div>
  );
};

export default UploadMenu;
